import { SimpleTransaction } from '@aptos-labs/ts-sdk';

interface EntryFunctionPayload {
  type: 'entry_function_payload';
  function: string;
  type_arguments: string[];
  arguments: any[];
}

interface TransactionWithPayload {
  rawTransaction: {
    payload: any;
  };
}

interface ArgumentValue {
  value?: any;
  data?: Uint8Array;
  values?: ArgumentValue[];
}

export class AptosUtils {
  static getTransaction(simpleTransaction: SimpleTransaction): any {
    if ('rawTransaction' in simpleTransaction) {
      const transaction = simpleTransaction as TransactionWithPayload;
      const { payload } = transaction.rawTransaction;

      if ('entryFunction' in payload) {
        const { entryFunction } = payload;
        const typeArguments: string[] = entryFunction.type_args.map(
          (tag: any) => tag.toString(),
        );
        const realArguments: any[] = [];
        this.getTypeArguments(entryFunction.args, realArguments);

        const result: EntryFunctionPayload = {
          type: 'entry_function_payload',
          function: `${
            entryFunction.module_name.address.data
              ? entryFunction.module_name.address.toString()
              : entryFunction.module_name.address
          }::${
            entryFunction.module_name.name.identifier
              ? entryFunction.module_name.name.identifier
              : entryFunction.module_name.name
          }::${
            entryFunction.function_name.identifier
              ? entryFunction.function_name.identifier
              : entryFunction.function_name
          }`,
          type_arguments: typeArguments,
          arguments: realArguments,
        };

        return this.getArguments(result);
      }
    }
    return simpleTransaction;
  }

  static getTypeArguments(args: ArgumentValue[], array: any[]): void {
    for (let j = 0; j < args.length; j++) {
      const y = args[j];
      if ('values' in y && y.values != null && y.values instanceof Array) {
        const subArray = [] as any[];
        array.push(subArray);
        this.getTypeArguments(y.values, subArray);
      } else {
        this.dealArrayElements(y, array);
      }
    }
  }

  static dealArrayElements(e: ArgumentValue, array: any[]): void {
    if ('value' in e && e.value != null) {
      array.push(e.value.toString());
    } else if (
      'data' in e &&
      e.data != null &&
      e.data instanceof Uint8Array
    ) {
      array.push(e.toString());
    } else {
      array.push(e.toString());
    }
  }

  static getArguments(e: any): any {
    if ('arguments' in e) {
      const t = e.arguments;
      if (Array.isArray(t)) {
        const r: any[][] = [];
        t.forEach((n: any) => {
          if (n instanceof Uint8Array) {
            const o: number[] = [];
            n.forEach((i: number) => {
              o.push(i);
            });
            r.push(o);
          } else {
            r.push(n);
          }
        });
        // eslint-disable-next-line no-param-reassign
        e = {
          ...e,
          arguments: r,
        };
      }
    }
    return e;
  }
}
